import InformeReproductivo from '../../features/informes/layouts/informe';

// TSS vite/01 — thin page. Monta los KPIs agregados del cliente (endpoint
// real GET public/stats?view=kpi). Guarded por <AuthRoute>; gateado en el nav
// a partner/donor_owner; cada bloque se gatea además por available_modules.

export default function InformesPage() {
    return <InformeReproductivo />;
}
